<ol class="breadcrumb">
    <li *ngFor="let breadcrumb of breadcrumbs">
        <span [routerLink]="breadcrumb.url" routerLinkActive="router-link-active">
        {{ breadcrumb.etiqueta }}
        </span>
    </li>
</ol>
